import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { SidebarEntry } from '../models/sidebarEntry';

@Injectable()
export class SideBarService {
    items  = new Subject<SidebarEntry[]>();

    getItems(): Observable<SidebarEntry[]> {
        return this.items;
    }

    setItems(items: SidebarEntry[]){
        this.items.next(items);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/sideBarService.ts